import { T } from "@repo/transifex";

import { StampcardCollectBadge } from "../ui/stampcard-collect-badge/stampcard-collect-badge";

export const StampcardCollectBanner = () => {
  return (
    <div className="flex w-full items-center gap-6 rounded-3xl bg-kiosk-accent-secondary/50 p-8">
      <StampcardCollectBadge count={1} />
      <div>
        <p className="text-4xl font-bold text-kiosk-text-primary">
          <T _str="Collect stamps" />
        </p>
        <p className="text-2xl text-kiosk-text-primary">
          <T _str="Earn stamps when you buy selected products and fill up your stamp card" />
        </p>
      </div>
    </div>
  );
};
